import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {changeField, initialize, readCommonDashboard} from '../../modules/admin/dashboard';

import Dashboard from '../../components/admin/dashboard/Dashboard';

export default function DashboardContainer() {
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { date_range, commonResponse, commonError, commonLoading } = useSelector(({ dashboard, loading }) => ({
        date_range: dashboard.date_range,
        commonResponse: dashboard.commonResponse,
        commonError: dashboard.commonError,
        commonLoading: loading['dashboard/READ_COMMON_DASHBOARD']
    }));

    const handleChange = (e) => {
        const { name, value } = e.target;
        dispatch(changeField({ name, value }));
    };

    const reloadCommon = () => {
        dispatch(readCommonDashboard({ date_range }));
    };

    useEffect(() => {
        dispatch(initialize());
    }, []);

    useEffect(() => {
        dispatch(readCommonDashboard({ date_range }));
    }, [date_range]);

    return (
        <Dashboard
            commonResponse={commonResponse}
            commonError={commonError}
            commonLoading={commonLoading}
            handleChange={handleChange}
            reloadCommon={reloadCommon}
        />
    );
}
